module.exports = __webpack_public_path__ + "static/media/spinner.0d7735cc.gif";